

export type MailParams = {
  tos: string[]
  subject: string
  text: string
  envelopFrom: string
  reps: string[]
  source: string,
  bccs?: string[]
  ccs?: string[]
  html?: string,
  inReplyTo?: string
}

export const getMailParams = (params: MailParams) =>{
  return {
    Destination: {
      BccAddresses: params?.bccs,
      CcAddresses: params?.ccs,
      ToAddresses: params?.tos
    },
    Message: {
      Subject: {
        Charset: "UTF-8",
        Data: params?.subject
      },
      Body: {
        Html: {
          Charset: "UTF-8",
          Data: params?.html
        },
        Text: {
          Charset: "UTF-8",
          Data: params?.text
        }
      }
    },
    ReplyToAddresses: params?.reps,
    ReturnPath: "return-path@support-desk.link",
    Source: params?.source,
  }
}

export const getMailOptions = (params: MailParams) => {

  const options = {
    from: params.source,
    to: params.tos,
    subject: params.subject,
    text: params.text,
    envelop: {
      from: params.envelopFrom
    }
  }
  if (params?.bccs && params?.bccs.length > 0) {
    options['bcc'] = params?.bccs.join(', ')
  }
  if (params?.ccs && params?.ccs.length > 0) {
    options['cc'] = params?.ccs.join(', ')
  }
  if (params?.html) {
    options['html'] = params?.html
  }
  if (params?.reps) {
    options['replyTo'] = params?.reps.join(', ')
  }
  if (params?.inReplyTo) {
    options['inReplyTo'] = params.inReplyTo
  }

  return options
}

export const hasCc = (sender) => {
  return sender?.ccs?.length > 0;
}
export const hasBcc = (sender) => {
  return sender?.bccs?.length > 0;
}

export const sanitizeEmail = (email) => {
  return email.replaceAll('.','d').replaceAll('-', 'h').replaceAll('+', 'p').replaceAll('_', 'u').replaceAll('@', 'a')
}

export const buildHeaderFrom = (name, email) => {
  return `${name} <${email}>`
}

export const textTemporaryReply = (name, text) => {
  return `${name || 'お客'}様\n
お問い合わせありがとうございます。\n
下記内容にてお問い合わせを承りました。\n
\n
----------------------------\n
${text}\n
----------------------------\n
\n
後ほど、記載いただいたメールアドレスへご連絡を差し上げます。\n
それまで今しばらくお待ちいただくようお願いいたします。\n
`
}

export const htmlTemporaryReply = (name, text) => {
  return `<p style='marginBottom: 1rem; overflow: "hidden";'>${name || 'お客'}様</p>
<p style='marginBottom: 1rem; overflow: "hidden";'>お問い合わせありがとうございます。<br />
下記内容にてお問い合わせを承りました。</p>

<blockquote>
  <p>${text.replaceAll('\n', '<br />')}</p>
</blockquote>

<p style='marginBottom: 1rem; overflow: "hidden";'>
後ほど、記載いただいたメールアドレスへご連絡を差し上げます。<br />
それまで今しばらくお待ちいただくようお願いいたします。
</p>
`
}